import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import ScrollToTop from "@/components/ScrollToTop";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import CookieConsent from "@/components/CookieConsent";
import Index from "./pages/Index";
import TransportRequest from "./pages/TransportRequest";
import CarrierApplication from "./pages/CarrierApplication";
import MentionsLegales from "./pages/MentionsLegales";
import CGU from "./pages/CGU";
import Auth from "./pages/Auth";
import MyRequests from "./pages/MyRequests";
import Blog from "./pages/Blog";
import TransportColisFranceMaroc from "./pages/TransportColisFranceMaroc";
import TransportBagagesFranceMaroc from "./pages/TransportBagagesFranceMaroc";
import PrixTransportColisMaroc from "./pages/PrixTransportColisMaroc";
import EnvoyerColisMarocVersFrance from "./pages/EnvoyerColisMarocVersFrance";
import EnvoyerColisMarocPasCher from "./pages/EnvoyerColisMarocPasCher";
import TransportColisMarocFiable from "./pages/TransportColisMarocFiable";
import TransporteursVerifiesMaroc from "./pages/TransporteursVerifiesMaroc";
import AvisTransportColisFranceMaroc from "./pages/AvisTransportColisFranceMaroc";
import FAQTransportColisMaroc from "./pages/FAQTransportColisMaroc";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import NouvelleAnnonceTransporteur from "./pages/NouvelleAnnonceTransporteur";
import AnnoncesTransporteurs from "./pages/AnnoncesTransporteurs";
import AnnonceDetail from "./pages/AnnonceDetail";
import HeroTest from "./pages/HeroTest";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <FloatingWhatsApp />
          <CookieConsent />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/demande-transport" element={<TransportRequest />} />
            <Route path="/devenir-transporteur" element={<CarrierApplication />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/mes-demandes" element={<MyRequests />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/transport-colis-france-maroc" element={<TransportColisFranceMaroc />} />
            <Route path="/transport-bagages-france-maroc" element={<TransportBagagesFranceMaroc />} />
            <Route path="/prix-transport-colis-maroc" element={<PrixTransportColisMaroc />} />
            <Route path="/envoyer-colis-maroc-vers-france" element={<EnvoyerColisMarocVersFrance />} />
            <Route path="/envoyer-colis-maroc-pas-cher" element={<EnvoyerColisMarocPasCher />} />
            <Route path="/transport-colis-maroc-fiable" element={<TransportColisMarocFiable />} />
            <Route path="/transporteurs-verifies-maroc" element={<TransporteursVerifiesMaroc />} />
            <Route path="/avis-transport-colis-france-maroc" element={<AvisTransportColisFranceMaroc />} />
            <Route path="/faq-transport-colis-maroc" element={<FAQTransportColisMaroc />} />
            <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/nouvelle-annonce-transporteur" element={<NouvelleAnnonceTransporteur />} />
            <Route path="/annonces-transporteurs" element={<AnnoncesTransporteurs />} />
            <Route path="/annonce/:id" element={<AnnonceDetail />} />
            <Route path="/hero-test" element={<HeroTest />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
